import { VIEW } from '@app/src/commons/sidebar/components/Sidebar/constants';
import * as actionTypes from './actionTypes';
import { serviceLoginMfa } from './services';
import { HttpStatus } from '@app/src/utils/validations/constants';

const fetchLoginRequest = () => ({
  type: actionTypes.FETCH_LOGIN_MFA_REQUEST
});

const fetchLoginResendOtp = () => ({
  type: actionTypes.FETCH_LOGIN_MFA_RESEND_OTP
});

const fetchLoginSessionTokenError = (errorMessage: string, msgType: string, errorRol?: boolean) => ({
  type: actionTypes.FETCH_LOGIN_MFA_SESSION_TOKEN_ERROR,
  errorMessage: errorMessage,
  msgType: msgType
});

const fetchLoginOtpError = (errorMessage: string, msgType: string) => ({
  type: actionTypes.FETCH_LOGIN_MFA_OTP_ERROR,
  errorMessage: errorMessage,
  msgType: msgType
});

const fetchLoginExceededOtpAttemptsError = (errorMessage: string, msgType: string) => ({
  type: actionTypes.FETCH_LOGIN_MFA_EXCEEDED_OTP_ATTEMPTS_ERROR,
  errorMessage: errorMessage,
  msgType: msgType
});

const fetchLoginSuccess = (data) => ({
  type: actionTypes.FETCH_LOGIN_MFA_SUCCESS,
  data
});

const redirectToLogin = async () => {
  const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
  await delay(3000);
  window.location.href = '/';
};
export const fetchValidateOtp = (values, history, url): Function => {
  return async dispatch => {
    dispatch(fetchLoginRequest());
    try {
      const data = await serviceLoginMfa.loginVerificateOtp(values, url);
      if (data.code === HttpStatus.LOGIN_SESSIONTOKEN_ERROR) {
        dispatch(fetchLoginSessionTokenError(data.message, 'error', true));
        return;
      } else if (data.code === HttpStatus.LOGIN_OTP_ERROR) {
        dispatch(fetchLoginOtpError(data.message, 'error'));
        return;
      } else if (data.code === HttpStatus.LOGIN_EXCEEDED_OTP_ATTEMPTS_ERROR) {
        dispatch(fetchLoginExceededOtpAttemptsError(data.message, 'error'));
        
        await redirectToLogin();
        return;
      }

      dispatch(fetchLoginSuccess(data));
      sessionStorage.setItem('accessToken', data.user.accessToken);
      sessionStorage.setItem('reportToken', data.user.reportToken);
      if(data.user.isMultipleServices){
        sessionStorage.setItem("isFlowMultMerch", "1");
        history.push(VIEW.SERVICES);
      }else{
        history.push(VIEW.CIP_GENERATION);
      }
      

    } catch(e) {
      const msg = 'Tiempo expirado, vuelva a autenticarse';
      dispatch(fetchLoginSessionTokenError(msg, 'error', true));
      
      await redirectToLogin();
    }
  }
}

export const resendOtp = (url: string) => {
  return async dispatch => {
    dispatch(fetchLoginResendOtp());
    try {
      const data = await serviceLoginMfa.resendOtp(url);      

      if (data.code === HttpStatus.LOGIN_SESSIONTOKEN_ERROR) {
        dispatch(fetchLoginSessionTokenError(data.message, 'error'));
        return;
      }
      
      dispatch(fetchLoginOtpError('Se ha enviado un nuevo código de verificación.', 'info'));

    } catch (e) {
      const msg = 'Tiempo expirado, vuelva a autenticarse';
      dispatch(fetchLoginSessionTokenError(msg, 'error', true));

      const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
      await delay(3000);
      window.location.href = '/';
    }
  };
};

